module.exports = __webpack_public_path__ + "img/ic_food_china.dd16104a.png";